import ELK from 'elkjs/lib/elk.bundled';

const elk = new ELK();

// Elk options:
//
// - https://www.eclipse.org/elk/reference/algorithms.html
// - https://www.eclipse.org/elk/reference/options.html

const DEFAULT_ELK_OPTIONS = {
  'elk.algorithm': 'org.eclipse.elk.force',
  'elk.spacing.nodeNode': '40',
  'elk.separateConnectedComponents': false,
};

const ELK_LAYOUT_WIDTH = 150;
const ELK_LAYOUT_HEIGHT = 85;

/**
 *
 * This algorithm computes a generally applicable default layout for React Flow diagrams used in the app.
 *
 * It applies the ELK Force algorithm to draw each connected component as a standalone embedded subgraph.
 *
 * @param {Node[]} nodes
 * @param {Edge[]} edges
 * @returns The nodes and edges with their positions derived from the layout
 */
const getDirectedGraphLayout = async (nodes, edges, options = {}) => {
  const graph = {
    id: 'root',
    layoutOptions: { ...options, ...DEFAULT_ELK_OPTIONS },
    children: nodes.map(node => ({
      ...node,

      // Hardcode a width and height for elk to use when layouting.
      width: ELK_LAYOUT_WIDTH,
      height: ELK_LAYOUT_HEIGHT,
    })),
    edges: edges,
  };

  try {
    const layoutedGraph = await elk.layout(graph);

    return {
      nodes: layoutedGraph.children.map(node => ({
        ...node,
        position: { x: node.x, y: node.y }, // React Flow expects a position property on the node instead of `x` and `y` fields.
      })),

      edges: layoutedGraph.edges,
    };
  } catch (message) {
    console.error(message);

    return undefined;
  }
};

export default getDirectedGraphLayout;
